import React from 'react';
import Tooltip from 'components/Tooltip/Tooltip';
import mapVopErrors from 'utils/payments/mapVopErrors';
import t from 'utils/translationHelper';

import { PaymentDto, PaymentVopMatchStatus } from '@alpha/payments-dtos';
import { Status } from '@alpha/ui-lib/ui/Status/Status';

const VOPStatus = ({
  payment,
  setSelectedPayment,
  clickable = true,
}: {
  payment: PaymentDto;
  setSelectedPayment: (payment: PaymentDto | undefined) => void;
  clickable?: boolean;
}) => {
  const requiredVerfication = payment.vopDetails?.status === PaymentVopMatchStatus.MATCH
    || payment.vopDetails?.status === PaymentVopMatchStatus.NOT_AVAILABLE
    || payment.vopDetails?.status === PaymentVopMatchStatus.NO_MATCH
    || payment.vopDetails?.status === PaymentVopMatchStatus.NEAR_MATCH
    || payment.vopDetails?.status === PaymentVopMatchStatus.FAILED;

  const getColor = (status?: PaymentVopMatchStatus, verified?:boolean, errors?:string[]) => {
    if (verified) { return 'success'; }
    if (errors && errors.length > 0) { return 'error'; }
    switch (status) {
      case PaymentVopMatchStatus.MATCH:
      case PaymentVopMatchStatus.NOT_AVAILABLE:
      case PaymentVopMatchStatus.NO_MATCH:
      case PaymentVopMatchStatus.NEAR_MATCH:
      case PaymentVopMatchStatus.FAILED:
        return 'orange';
      default:
        return 'default';
    }
  };

  const getText = (status?: PaymentVopMatchStatus, verified?:boolean, errors?:string[]) => {
    if (verified) { return t('VERIFIED'); }
    if (errors && errors.length > 0) { return t('ERROR'); }
    switch (status) {
      case PaymentVopMatchStatus.MATCH:
      case PaymentVopMatchStatus.NOT_AVAILABLE:
      case PaymentVopMatchStatus.NO_MATCH:
      case PaymentVopMatchStatus.NEAR_MATCH:
      case PaymentVopMatchStatus.FAILED:
        return t('VERIFICATION REQUIRED');
      default:
        return t('NOT REQUIRED');
    }
  };

  const errorMessage =  mapVopErrors(payment.vopDetails?.vopErrors || []) ;
  const hasErrors = payment.vopDetails?.vopErrors && payment.vopDetails?.vopErrors.length > 0;

  return (
    <Tooltip title={hasErrors ? errorMessage : ''} placement="bottom-start">
      <div>
      <Status
        variant={getColor(payment.vopDetails?.status, payment.vopDetails?.vopApprovalAcknowledged, payment.vopDetails?.vopErrors)}
        onClick={() => clickable && setSelectedPayment(payment)}
      >
        <div
          style={{
            textDecoration: requiredVerfication ? 'underline' : 'none',
            minWidth: requiredVerfication ? '120px' : undefined,
            textAlign: 'center',
            fontSize: '13px',
            fontWeight: '600',
            letterSpacing: 'normal',
            cursor: clickable ? 'pointer' : 'default',
          }}
        >
          {getText(payment.vopDetails?.status, payment.vopDetails?.vopApprovalAcknowledged, payment.vopDetails?.vopErrors)}
        </div>
      </Status>
      </div>
    </Tooltip>
  );
};

export default VOPStatus;
